const loader = {
  name: 'loader'
};

export default loader
